import axios from "axios";

const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("ps_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  const v = localStorage.getItem("ps_active_venue");
  if (v && !cfg.headers["X-Venue-Id"]) cfg.headers["X-Venue-Id"] = v;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && !e.config?.url?.includes("/auth/")) {
      localStorage.removeItem("ps_token");
      const path = window.location.pathname;
      const target = path.startsWith("/plus") ? "/plus/login" : "/login";
      if (path !== target) window.location.href = target;
    }
    return Promise.reject(e);
  }
);

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Errore";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d?.code === "DUPLICATE_PHONE") return "Numero già registrato";
  if (d?.code === "DUPLICATE_TICKET") return "❌ TICKET GIÀ UTILIZZATO";
  return d?.msg || JSON.stringify(d);
}

export function imgUrl(url) {
  if (!url) return null;
  return url.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url;
}

export default api;
